export default __webpack_public_path__ + "media/images/uk_flag.png";